import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TagComponent, TagVariant } from '@catch/general-ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlatformApplication } from '../../../../models/platform.models';
import { PlatformApplicationStatus } from '../../../../enums/platform-application-status.enum';
import { PlatformDashboardService } from '../../../../services/platform-dashboard.service';

@Component({
  selector: 'app-platform-dashboard-application-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TagComponent, FontAwesomeModule, TranslocoPipe],
  templateUrl: './platform-dashboard-application-item.component.html',
  styleUrl: './platform-dashboard-application-item.component.scss',
})
export class PlatformDashboardApplicationItemComponent {
  readonly dashboard = inject(PlatformDashboardService);
  readonly application = input.required<PlatformApplication>();

  readonly TagVariant = TagVariant;
  readonly icons = {
    chevronRight: faChevronRight,
  };

  readonly statusTagVariant = computed(() => {
    switch (this.application().status) {
      case PlatformApplicationStatus.INCOMPLETE:
        return TagVariant.YELLOW;
      case PlatformApplicationStatus.PROCESS_ENDED:
        return TagVariant.GRAY;
      default:
        return TagVariant.DEFAULT;
    }
  });
}
